import React, { useEffect, useState } from 'react';
import SystemDashboard from 'layouts/SystemDashboard';
import {
  getAllItems,
  deleteItem,
  // getItem,
  // saveItem,
  // updateItem,
} from './ItemService';
import { getSection } from '../Sections/SectionService';
import {
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Breadcrumbs,
  Link,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { alpha, useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Container from 'components/Container';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const ItemList = (): JSX.Element => {
  const theme = useTheme();
  const [items, setItems] = useState<any[]>([]);
  const { sectionid = '' } = useParams<{ sectionid: string }>();
  const [pageTitle, setPageTitle] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    listItems(sectionid);
    getPageTitle(sectionid);
  }, [sectionid]);

  function listItems(sectionid) {
    setLoading(true);
    const sectionIdAsNumber: number = parseInt(sectionid);
    getAllItems(sectionIdAsNumber)
      .then((response) => {
        setItems(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function addItem() {
    navigate(`/system/dashboard/section/${sectionid}/item/add-item`);
  }

  function selectItem(itemid) {
    console.log(itemid);
    navigate(`/system/dashboard/section/${sectionid}/item/${itemid}`);
  }

  const handleDeleteConfirmation = (itemId) => {
    setItemIdToDelete(itemId);
    setOpenDialog(true);
  };

  const handleDeleteItem = () => {
    removeItem(itemIdToDelete);
    setOpenDialog(false);
  };

  function removeItem(itemid) {
    deleteItem(itemid)
      .then(() => {
        listItems(sectionid);
      })
      .catch((error) => {
        // Handle errors or exceptions
        if (error.response) {
          // The request was made and the server responded with a status code
          // Display an error message based on the response status
          console.error(
            'Request failed with status code:',
            error.response.status,
          );
          // Check if the error is due to a foreign key constraint violation
          if (
            error.response.status === 400 &&
            typeof error.response.data === 'string' &&
            error.response.data.includes('foreign key constraint')
          ) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete the item because it is referenced by other records.',
            );
          }
          if (error.response.status === 401) {
            // Display a user-friendly error message informing the user that they can't delete the item
            notify(
              'Cannot delete or update a parent row: a foreign key constraint fails.',
            );
          } else {
            // Display a generic error message for other types of errors
            notify(
              'An error occurred while deleting the item. Please try again later.',
            );
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error(
            'Request made but no response received:',
            error.request,
          );
        } else {
          // Something happened in setting up the request that triggered an error
          console.error('Error setting up the request:', error.message);
        }
      });
  }

  function getPageTitle(sectionid) {
    getSection(sectionid)
      .then((response) => {
        setPageTitle(response.data.name);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <Container>
      <SystemDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Typography color="text.primary">{pageTitle}</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">{pageTitle}</Typography>
          <Button variant="contained" onClick={addItem}>
            Add Item
          </Button>
        </Box>
        {loading && <p>Loading...</p>}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 750 }} aria-label="simple table">
            <TableHead sx={{ bgcolor: 'alternate.main' }}>
              <TableRow>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    ID
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Item Name
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Version Number
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Build Number
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'text.secondary'}
                    variant={'caption'}
                    fontWeight={700}
                    sx={{ textTransform: 'uppercase' }}
                  >
                    Status
                  </Typography>
                </TableCell>
                <TableCell />
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                  Are you sure you want to delete this item?
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                  <Button onClick={handleDeleteItem} autoFocus>
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
              {items
                .sort((a, b) => a.id - b.id)
                .map((item, i) => (
                  <TableRow
                    key={i}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    onClick={() => selectItem(item.id)}
                  >
                    <TableCell component="th" scope="row">
                      <ListItem sx={{ p: 0, m: 0 }}>
                        <ListItemAvatar>
                          {/* <Avatar src={} /> */}
                        </ListItemAvatar>
                        <ListItemText primary={item.id} />
                      </ListItem>
                    </TableCell>
                    <TableCell>
                      <Typography>{item.name}</Typography>
                      {/* <Typography
                        color={'text.secondary'}
                        variant={'subtitle2'}
                      >
                        {item.name}
                      </Typography> */}
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant={'caption'}
                        fontWeight={700}
                        sx={{
                          bgcolor: alpha(theme.palette.success.light, 0.1),
                          color: theme.palette.success.dark,
                          paddingX: 1.5,
                          paddingY: 0.5,
                          borderRadius: 4,
                          display: 'inline',
                        }}
                      >
                        {item.versionNumber}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color={'text.secondary'}
                        variant={'subtitle2'}
                      >
                        {item.buildNumber}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color={'text.secondary'}
                        variant={'subtitle2'}
                      >
                        {item.status}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color={'primary'}
                        variant={'subtitle2'}
                        fontWeight={700}
                        sx={{ cursor: 'pointer' }}
                      >
                        Edit
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography
                        color={'primary'}
                        variant={'subtitle2'}
                        fontWeight={700}
                        sx={{ cursor: 'pointer' }}
                      >
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation(); // Stop the click event from propagating
                            handleDeleteConfirmation(item.id); // Show confirmation dialog before deleting
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </SystemDashboard>
    </Container>
  );
};

export default ItemList;
